if($(".nav-pills").length) {

    $('.nav-pills.desktop-only-tabs').each(function (i, e) {

        let parent = $(this).parent();

        if($(this).data('target-parent')) {
            parent= $($(this).data('target-parent'));
        }

        let popupMenu = parent.find('.detail-nav-mobile-menu'),
            tabItems = popupMenu.find('.nav-link'),
            tabDisplay = parent.find('.detail-nav-mobile-label span'),
            prevButton = parent.find('button.prev'),
            nextButton = parent.find('button.next'),
            popupMenuButton = parent.find('.detail-nav-mobile-label');

        popupMenuButton.on('click', function() {
            if(popupMenu.hasClass('active')) {
                popupMenu.removeClass('active');
                setTimeout(function () {
                    popupMenu.hide();
                }, 310);
            } else {
                popupMenu.show();
                setTimeout(function () {
                    popupMenu.addClass('active');
                }, 10);
            }
        });

        tabItems.on('click', function() {
            let tabText = $(this).text();
            tabDisplay.text(tabText);
            popupMenu.removeClass('active');
            setTimeout(function () {
                popupMenu.hide();
                prevNextStatus();
            }, 310);
        });

        prevButton.on('click', function() {
            let activeTab = tabItems.filter('.active'),
                prevTab = activeTab.parent().prev();

            if(prevTab.length) {
                prevTab.find('a').trigger('click');
            }

            prevNextStatus();
        });

        nextButton.on('click', function() {
            let activeTab = tabItems.filter('.active'),
                nextTab = activeTab.parent().next();

            if(nextTab.length) {
                nextTab.find('a').trigger('click');
            }

            prevNextStatus();
        });

        function prevNextStatus() {

            let activeTab = tabItems.filter('.active'),
                prevTab = activeTab.parent().prev(),
                nextTab = activeTab.parent().next();

            if(prevTab.length) {
                prevButton.removeAttr('disabled');
                prevButton.removeClass('is-disabled');
            } else {
                prevButton.attr('disabled', 'disabled');
                prevButton.addClass('is-disabled');
            }

            if(nextTab.length) {
                nextButton.removeAttr('disabled');
                nextButton.removeClass('is-disabled');
            } else {
                nextButton.attr('disabled', 'disabled');
                nextButton.addClass('is-disabled');
            }

        }

        prevNextStatus();

    });

}
